// https://gist.github.com/jed/982883

// https://caniuse.com/mdn-api_crypto_randomuuid
export const uuid = (): string => crypto?.randomUUID?.() || randomUUID();

// TODO: remove when IE and Safari < 15.4 support is dropped
const randomUUID = () =>
  // prettier-ignore
  // @ts-expect-error adding number and array
  (([1e7]+-1e3+-4e3+-8e3+-1e11) as string).replace(/[018]/g, (c: number) =>
    // eslint-disable-next-line no-bitwise
    (c ^ random() >> c / 4).toString(16)
  );

// TODO: remove Math.random when Opera Mini support is dropped - https://caniuse.com/getrandomvalues
const random = () =>
  // eslint-disable-next-line no-bitwise
  (crypto?.getRandomValues?.(new Uint8Array(1))[0] ?? Math.random() * 16) & 15;

const crypto = window.crypto || globalThis.crypto;

// TODO: remove workaround when tsconfig or TypeScript is updated
declare global {
  interface Crypto {
    randomUUID(): string;
  }
}
